module.exports = __webpack_public_path__ + "static/media/copy_icon.7ab0d5f3.png";